import { useState, useCallback, useContext } from "react"
import { useScrollPosition } from "../hooks"
import { Link, Button } from "../Hyper"
import { Wrapper } from "../Wrapper"
import { Context } from "./Container"
import { Media } from "../Media"
import { Icon } from "./Footer/assets/linkedin"
import { Logo } from "../Logo"
import * as RowShift from "../RowShift"
import styles from "./styles.module.scss"
import cn from "clsx"
import type { FC, HTMLAttributes, UIEventHandler } from "react"

export interface NavigationItem {
  path: string,
  text: string,
  description: string,
}

interface NavigationProps
extends HTMLAttributes<HTMLDivElement> {
  map: NavigationItem[]
}

const IGNORANCE_SPACE = 100

export const Navigation: FC<NavigationProps> = ({ className, map, ...rest }) => {
  const { content } = useContext(Context)
  const [ isHidden, setHiddenState ] = useState(false)
  const [ isOpen, setOpenState ] = useState(false)
  const clickHandler: UIEventHandler<HTMLUListElement> = useCallback(event => {
    const target = event.nativeEvent.target as HTMLElement
    if (target.classList.contains(styles.link)) setOpenState(false)
  }, [])
  
  useScrollPosition.Effect(scroll => {
    if (scroll.y < IGNORANCE_SPACE) return setHiddenState(false)
    else setHiddenState(scroll.direction.y > 0)
  }, [setHiddenState])

  return (
    <div {...rest} className={cn(styles.navigation, { [styles.hidden]: isHidden && !isOpen })}>
      <Wrapper limitedWidth={false} className={styles.wrapper}>
        <div className={styles.side}>
          <Link seamless href="/" className={styles.logo}>
            <Logo />
          </Link>
          <Media till="desktopS">
            <Button theme="white" onClick={setOpenState.bind(0, !isOpen)}>
              <RowShift.Container index={+isOpen}>
                <RowShift.Item>MENU</RowShift.Item>
                <RowShift.Item>CLOSE</RowShift.Item>
              </RowShift.Container>
            </Button>
          </Media>
        </div>
        <Media from={450}>
          <div className={styles.side}>
            <Media from="desktopS">
              <ul className={styles.menu}>
                {map.map(({ path, description, text }, index) => (
                  <li className={styles.item} key={index}>
                    <span className={styles.numeration}>
                      {index.toString().padStart(2, '0')}.
                    </span>
                    <Link seamless className={styles.link}
                      title={description}
                      href={path}>
                      {text}
                    </Link>
                  </li>
                ))}
              </ul>        
            </Media>
            <Link type="bordered" target="_blank"
              href="https://www.linkedin.com/comm/mynetwork/discovery-see-all?usecase=PEOPLE_FOLLOWS&followMember=pavlovalor">
              Follow on
              <Icon className={styles.li} />
            </Link>
          </div>
        </Media>
      </Wrapper>
      <Media till="desktopS">
        <div className={cn(styles.overlay, { [styles.open]: isOpen })}>
          <Wrapper>
            <ul className={styles.menu} onClick={clickHandler}>
              {map.map(({ text, path, description }, index) => (
                <li className={styles.item} key={index}>
                  <Link className={styles.link} href={path}>
                    {text}
                  </Link>
                  <p className={styles.description}>
                    {description}
                  </p>
                </li>
              ))}
            </ul>
          </Wrapper>
        </div>
      </Media>
    </div>
  )
}
